import React from 'react'
interface Props {
  title: string
  descriptions: string[]
}

const AboutPlatform: React.FC<Props> = ({ title, descriptions }) => {
  return (
    <section>
      <div className="max-desktop-width  |  mx-auto py-12 px-5 lg:px-6 lg:py-22">
        <header
          className="text-center  |  mb-8 mx-auto "
          style={{ maxWidth: 784 }}
        >
          <h2 className="h3 font-medium">{title}</h2>
        </header>
        {descriptions.length !== 0 &&
          descriptions.map((description, idx) => (
            <p
              key={`${idx}-about-translation`}
              className="text-paragraph-3 text-gray-70 | mb-6"
            >
              {description}
            </p>
          ))}
      </div>
    </section>
  )
}

export default AboutPlatform
